document.addEventListener('DOMContentLoaded', function() {
  const searchInputs = document.querySelectorAll('.siloek-search-input');
  
  if (!searchInputs.length) return;

  searchInputs.forEach(input => {
    const form = input.closest('.siloek-search-bar');
    if (!form) return;

    // Create the predictive wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'siloek-predictive-dropdown';
    wrapper.style.display = 'none';
    
    // In desktop, the form is inside siloek-desktop-search-container
    // We want the dropdown to be relative to the container.
    // Ensure the container has position: relative if it doesn't already
    if (form.parentNode.style.position !== 'absolute') {
      form.parentNode.style.position = 'relative';
    }
    
    form.parentNode.appendChild(wrapper);

    const openWrapper = () => {
      wrapper.style.display = 'flex';
    };

    let debounceTimer;

    input.addEventListener('input', function() {
      const query = this.value.trim();
      
      clearTimeout(debounceTimer);
      
      if (query.length < 2) {
        wrapper.style.display = 'none';
        return;
      }

      debounceTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=query,product&resources[limit]=4`)
          .then(res => res.json())
          .then(data => {
            const queries = data.resources.results.queries || [];
            const products = data.resources.results.products || [];

            if (queries.length === 0 && products.length === 0) {
              wrapper.style.display = 'none';
              return;
            }

            let queriesHtml = queries.map(q => `
              <li><a href="${q.url}">${q.styled_text}</a></li>
            `).join('');

            let productsHtml = products.map(p => `
              <a href="${p.url}" class="siloek-pred-product">
                <div class="siloek-pred-img">
                  ${p.image ? `<img src="${p.image}" alt="">` : ''}
                </div>
                <div class="siloek-pred-info">
                  <div class="siloek-pred-brand">${p.vendor || 'Siloek'}</div>
                  <div class="siloek-pred-title">${p.title}</div>
                  <div class="siloek-pred-price">${p.price}</div>
                </div>
              </a>
            `).join('');

            wrapper.innerHTML = `
              <div class="siloek-pred-left">
                <div class="siloek-pred-heading">SUGERENCIAS</div>
                <ul class="siloek-pred-queries">
                  ${queriesHtml}
                </ul>
              </div>
              <div class="siloek-pred-right">
                <div class="siloek-pred-heading">PRODUCTOS PARA "${query.toUpperCase()}"</div>
                <div class="siloek-pred-product-list">
                  ${productsHtml}
                </div>
                <a href="/search?q=${encodeURIComponent(query)}" class="siloek-pred-all-btn">Ver todos los productos</a>
              </div>
            `;
            openWrapper();
          })
          .catch(err => console.error("Predictive search error:", err));
      }, 300);
    });

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (!wrapper.contains(e.target) && e.target !== input) {
        wrapper.style.display = 'none';
      }
    });
    
    // Open when focusing input if there's text
    input.addEventListener('focus', function() {
      if (this.value.trim().length >= 2 && wrapper.innerHTML.trim() !== '') {
        openWrapper();
      }
    });
  });
});
